import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, Link } from "react-router-dom";
// ✅ IMPORT HEADER FOOTER
import TopHeader from "../../Header/TopHeader";
import Navbar from "../../Header/Navbar";
import Footer from "../../Footer/Footer";
import Breadcrumb from "../../Screens/Breadcrumb";
function Propitorship() {
  const location = useLocation();
  const serviceId = location.state?.id;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  // ======================
  // API CALL
  // ======================
  const getServiceDetails = async () => {
    try {
      const res = await axios.get(
        `https://api.compliancekare.com/api/Compliance/ServiceDetailList?BusinessId=${serviceId}`
      );

      console.log("API RESPONSE:", res.data);

      const result = res?.data?.id || null;

      setData(result);

    } catch (error) {
      console.error("API ERROR:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (serviceId) getServiceDetails();
  }, [serviceId]);

  return (
    <>
      {/* ✅ HEADER */}
      <TopHeader />
      <Navbar />
      <Breadcrumb 
        title={data ? data.serviceName : "Service Details"} 
        pageName={data ? data.serviceName : "Services"} 
      />

      {/* ✅ MAIN CONTENT */}
      <div className="container mt-4 mb-5">
        {loading ? (
          <p>Loading...</p>
        ) : data ? (
          <div className="row">
            <div className="col-lg-8">
              <div className="card p-4 shadow-sm border-0 rounded-3 mb-4" style={{ background: "rgba(255,255,255,0.9)" }}>
                <h3 className="fw-bold mb-3" style={{ color: "#115886" }}>{data.serviceName}</h3>
                <hr className="my-3" />
                <div
                  className="service-description"
                  dangerouslySetInnerHTML={{
                    __html: data.proprietorshipDescription || ""
                  }}
                />
              </div>
            </div>
            
            <div className="col-lg-4">
              <div className="sticky-sidebar-card">
                <h4 className="fw-bold mb-3" style={{ color: "#115886", fontSize: "20px" }}>Secure Checkout</h4>
                <p className="text-muted small mb-4">Complete your payment details to start processing your registration instantly.</p>
                
                <div className="sidebar-price-box">
                  <span className="text-muted small d-block mb-1">Package Pricing</span>
                  <h3 className="fw-extrabold m-0" style={{ color: "#115886", fontSize: "28px", fontWeight: "800" }}>
                    {data.price ? `₹${data.price}.00` : "Custom Pricing"}
                  </h3>
                </div>

                <Link to="/contact" className="sidebar-pay-btn hover-lift mb-4">
                  💳 Pay Now
                </Link>

                <div className="border-top pt-4 text-start">
                  <div className="sidebar-benefit-item">
                    <span>✔</span> 100% Assured Services
                  </div>
                  <div className="sidebar-benefit-item">
                    <span>✔</span> Expert CA Consultation
                  </div>
                  <div className="sidebar-benefit-item">
                    <span>✔</span> Secure Encrypted Transaction
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <p>No Data Found</p>
        )}

      </div>

      {/* ✅ FOOTER */}
      <Footer />
    </>
  );
}

export default Propitorship;